import { useShouldShowDevTeamFeature } from './_base';

export const useMetricFilterMappingFeature = useShouldShowDevTeamFeature;
